import { findMany, whenElementIsInView } from '../Libraries/helpers';

findMany('[data-bg-image]').forEach(element => {
    whenElementIsInView(element, visible => {
        if (visible) {
            element.style.backgroundImage = `url(${element.dataset.bgImage})`;
        }
    })
});
